import React from 'react';

// Misnomer: this component does not preload anything anymore. The
// previously-eager `new Image()` fetch was redundant with the <img> tag
// the component renders, so we removed it. The component is kept (rather
// than inlined) because it's used in 30+ places across the app.
const PreloadedImages = ({ src, alt, className }) => (
  <img
    src={src}
    alt={alt}
    className={className}
    loading="lazy"
    decoding="async"
  />
);

export default PreloadedImages;
